import styled from 'react-emotion';
import { theme } from '@ublend-npm/aulaui-next';

export const Container = styled('div')`
  height: 100%;
  flex: 1;
`;

export const TitleContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${theme.spacing.medium};

  span.material-section-title-disabled {
    color: ${theme.color.designSystem.blackOpacity87};
  }
`;

export const PreviewBanner = styled('span')`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
`;

export const LastEditedContainer = styled('div')`
  color: ${theme.color.blackAlpha(0.6)};
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  margin-bottom: ${theme.spacing.medium};
`;

export const ContentContainer = styled('div')`
  border: 1px solid ${theme.color.blackAlpha(0.12)};
  border-radius: 4px;
  padding: ${theme.spacing.medium};
  height: calc(100% - 120px);
  overflow-y: auto;
`;
